// add a .toJSON() to an observable so that it will serialize its value to JSON
export function jsonableObservable<T extends () => any>(obs : T) : T {
    if (typeof obs !== 'function') throw "jsonable: must be a function";
    (obs as any).toJSON = toJSON;
    return obs;
}

function toJSON(this : () => any) {
    var json = this();
    // if we shadowed the value's own toJSON, call it now
    if (json && json.toJSON) json = json.toJSON();
    return json;
}


// WEBPACK FOOTER //
// ./lib/jsonableObservable.ts